export default state => ({
    ...state,
    ticketTypeOnFocus: null,
});
